module.exports = "/shared/img/btn-background.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/btn-background.png
// module id = 24
// module chunks = 13